import { render, staticRenderFns } from "./KEN.vue?vue&type=template&id=edde0e66&scoped=true&"
import script from "./KEN.vue?vue&type=script&lang=js&"
export * from "./KEN.vue?vue&type=script&lang=js&"
import style0 from "./KEN.vue?vue&type=style&index=0&id=edde0e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edde0e66",
  null
  
)

export default component.exports